<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		}
	}
</script>

<style>
	* {
		padding: 0;
		margin: 0;
	}
	/* 引入侧边栏图标 */
	@import url('./public/font/iconfont.css');
	/* 页面中添加/筛选 */
	.card_box{
		padding: 20px;
		border-radius: 8px;
		margin-bottom: 20px;
		background-color: #fff;
		margin-bottom: 20px;
	}
	/* 页面内容 */
	.back_box {
		border-radius: 8px;
		padding: 20px;
		background-color: #fff;
	}
</style>